<template>
    <a-spin
        :spinning="tagsLoading"
    >
        <SearchSelect 
            v-if="!tagsLoading"
            :label="label"
            :selected="selectedTags"
            :options="tagOptions"
            v-model="selectedTags"
        />
    </a-spin>
</template>

<script>
import SearchSelect from './SearchSelect.vue';
import { getTags } from '../../../http/api';

export default {
    name: 'TagsSearchSelectWrapper',
    props: {
        label: String,
        tagType: {
            type: String,
            default: 'empty'
        },
        selected: Array
    },

    model: {
        prop: 'selected',
        event: 'selectedChange'
    },

    components: {
        SearchSelect
    },

    data() {
        return {
            tagsLoading: false,
            tagOptions: []
        }
    },

    created() {
        this.tagsLoading = true;
        getTags({
            params: {
                type: this.tagType
            }
        }).then(res => {
            this.tagOptions = res.data.data.map(tag => {
                
                return {
                    value: `${tag.id}`,
                    label: tag.name
                };
            });
            this.tagsLoading = false;
        })
    },

    computed: {
        selectedTags: {
            get() {
                return this.selected.map(option => {
                    return {
                        label: option.name,
                        key: `${option.id}`
                    }
                })
            },
            set(val) {
                const mappedVal = val.map(option => {
                    return {
                        name: option.label,
                        id: option.key
                    }
                })
                this.$emit('selectedChange', mappedVal);
            }
        }
    }
}
</script>

<style>

</style>